import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { HydraulicSchematicStore } from '@store';

import { SvgVddMapping } from '../../../../../../projects/client';

@Component({
  selector: 'app-hydraulic-schematic-vdd-table',
  templateUrl: './hydraulic-schematic-vdd-table.component.html',
  styleUrls: ['./hydraulic-schematic-vdd-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HydraulicSchematicVddTableComponent implements OnInit, OnDestroy {
  svgVdds: SvgVddMapping[];

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(private hydraulicSchematicStore: HydraulicSchematicStore) {}

  ngOnInit(): void {
    this.hydraulicSchematicStore.getHydraulicSchematicVdds$
      .pipe(
        takeUntil(this.ngUnsubscribe$),
        filter((svgVddMapping) => !!svgVddMapping?.length)
      )
      .subscribe((svgVdds) => {
        this.svgVdds = svgVdds;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
